import { useQuery } from "@tanstack/react-query";
import { getProfiles } from "@/api/profile";
import { ProfilesFilters } from "@/api/profile/types";


export function useProfiles(filters?: ProfilesFilters) {
  return useQuery({
    queryKey: ['profiles', filters],
    queryFn: () => getProfiles(filters),
    staleTime: 30000, // Consider data fresh for 30 seconds
    retry: (failureCount, error) => {
      // Only retry network errors, not 4xx errors
      if (error.status && error.status >= 400 && error.status < 500) {
        return false;
      }
      return failureCount < 3;
    },
  });
}